
    import { mapState } from 'vuex';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import {
        faAngleRight as farAngleRight,
    } from '@fortawesome/pro-regular-svg-icons/faAngleRight';

    import {
        faInfoCircle as farInfoCircle,
    } from '@fortawesome/pro-regular-svg-icons/faInfoCircle';

    import {
        faExclamationTriangle as farExclamationTriangle,
    } from '@fortawesome/pro-regular-svg-icons/faExclamationTriangle';

    import {
        faBell as farBell,
    } from '@fortawesome/pro-regular-svg-icons/faBell';

    import {
        faList as fasList,
    } from '@fortawesome/pro-solid-svg-icons/faList';

    import {
        faChevronRight as fasChevronRight,
    } from '@fortawesome/pro-solid-svg-icons/faChevronRight';

    import {
        faExternalLinkAlt as fasExternalLinkAlt,
    } from '@fortawesome/pro-solid-svg-icons/faExternalLinkAlt';

    import {
        faChevronDown as fasChevronDown,
    } from '@fortawesome/pro-solid-svg-icons/faChevronDown';

    import {
        faBellOn as fasBellOn,
    } from '@fortawesome/pro-solid-svg-icons/faBellOn';

    import JobSlideLoading from '@/components/Utils/JobSlideLoading';
    import Dropdown from '@/components/Utils/Dropdown';
    import JobScroll from '@/components/Job/JobScroll';
    import JobSlide from '@/components/Job/JobSlide';
    import NoJobs from '@/components/Job/NoJobs';
    import { Bus } from '@/utils/bus';
    import SaveSearch from '@/components/SaveSearch/SaveSearch';
    import ADFJobsBanner from '@/components/Ad/ADFJobsBanner';
    import ADFJobsBannerSm from '@/components/Ad/ADFJobsBannerSm';

    export default {
        name: 'JobWidget',

        components: {
            JobSlideLoading,
            Dropdown,
            JobScroll,
            JobSlide,
            NoJobs,
            SaveSearch,
            ADFJobsBanner,
            ADFJobsBannerSm,
            FontAwesomeIcon,
        },

        props: {
            label: {
                type: String,
                default: '',
            },

            description: {
                type: String,
                default: '',
            },

            labelIcon: {
                type: Array,
                default: () => [],
            },

            isDark: {
                type: Boolean,
                default: false,
            },

            searchFilter: {
                type: Object,
                required: false,
                default: () => {},
            },

            jobsUrl: {
                type: String,
                required: false,
                default: '',
            },

            jobsPayload: {
                type: Array,
                required: false,
                default: () => [],
            },

            to: {
                type: String,
                default: '',
            },

            hideEmpty: {
                type: Boolean,
                default: false,
            },

            rowType: {
                type: String,
                default: '',
            },

            rowPosition: {
                type: Number,
                default: 0,
            },

            rowTypeId: {
                type: String,
                default: '',
            },

            currentFrequency: {
                type: String,
                default: '',
            },

            rowId: {
                type: Number,
                required: false,
                default: null,
            },

            showListViewButton: {
                type: Boolean,
                default: false,
            },

            hideAlert: {
                type: Boolean,
                default: false,
            },

            target: {
                type: String,
                default: '_self',
            },

            slideOverlayColor: {
                type: String,
                default: 'white',
                validator: (value) => {
                    return ['white', 'light'].includes(value);
                },
            },
        },

        data() {
            return {
                jobs: [],
                hide: false,
                spinner: {
                    get_jobs: true,
                },
                alertFrequency: [
                    {
                        label: 'Off',
                        value: 'NEVER',
                    },
                    {
                        label: 'Daily',
                        value: 'DAILY',
                    },
                    {
                        label: 'Weekly',
                        value: 'WEEKLY',
                    },
                ],
                selectedFrequency: this.currentFrequency,
                icons: {
                    fasList,
                    fasChevronDown,
                    farAngleRight,
                    farInfoCircle,
                    fasChevronRight,
                    farExclamationTriangle,
                    fasExternalLinkAlt,
                    farBell,
                    fasBellOn,
                },
            };
        },

        computed: {
            ...mapState({
                $_appInfo: state => state.appInfo,
                $_me: state => state.me.user,
                $_user: state => state.user.user,
            }),

            classList() {
                return [
                    'slide-row',
                    this.getRowTypeVariationClass,
                    this.getDarkClass,
                    this.getNoJobsClass,
                    this.getNoSavedJobsClass,
                ];
            },

            getRowTypeVariationClass() {
                return `slide-row-${this.rowTypeId}`;
            },

            getDarkClass() {
                return this.isDark ? 'is-dark' : '';
            },

            getNoJobsClass() {
                return !this.jobs.length && !this.spinner.get_jobs ? 'no-jobs' : '';
            },

            getNoSavedJobsClass() {
                return !this.jobs.length && !this.spinner.get_jobs && this.isSavedJob ? 'no-saved-jobs' : '';
            },

            isSavedJob() {
                return this.label === 'Saved jobs';
            },

            isMeOnboarded() {
                return this.$_me.id && this.$_me.profile_status === 'onboarded';
            },

            isNonLoggedInUserOnboarded() {
                return this.$_user && this.$_user.profile_status === 'onboarded';
            },

            classListAlertDropdown() {
                return [
                    'slide-row-dropdown',
                    this.getHasFrequencyClass,
                ];
            },

            getHasFrequencyClass() {
                return this.isFrequencySelected ? '' : 'is-active';
            },

            getCurrentFrequency() {
                if (!this.selectedFrequency || this.selectedFrequency === 'NEVER') {
                    return 'Alert Off';
                } else {
                    return this.normalizedCurrentFrequency;
                }
            },

            isFrequencySelected() {
                return !this.selectedFrequency || this.selectedFrequency === 'NEVER';
            },

            normalizedCurrentFrequency() {
                return this.selectedFrequency.charAt(0).toUpperCase() + this.selectedFrequency.substring(1).toLowerCase();
            },

            manageEmailAlertsLink() {
                const baseRoute = process.env.BASE_ROUTE !== '/' ? process.env.BASE_ROUTE : '';
                return `${baseRoute}/settings#notifications`;
            },

            showAlertDropdown() {
                if (this.$_me.id && this.$_me.profile_status !== 'onboarded') {
                    return false;
                } else if (!this.$_me.id && !this.isNonLoggedInUserOnboarded) {
                    return false;
                } else if (this.rowType === 'LAST_SEARCH' || this.rowType === 'ACTIVITY' || this.rowType === 'SIMILAR_JOBS' || this.rowType === 'SEARCH_PAGE') {
                    return false;
                }
                return true;
            },

            getTitleLink() {
                let titleLink = this.to;
                if (this.rowTypeId === 'adf-jobs') {
                    return titleLink;
                }
                const routeQuery = this.$route.query;
                const query = Object.keys(routeQuery).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(routeQuery[key])}`).join('&');
                if (query) {
                    titleLink += `?${query}`;
                }
                return `${this.$siteUrl}${titleLink}`;
            },
        },

        async mounted() {
            await this.getJobs();
            Bus.$on('onToggleJobVisibility', (data) => {
                const index = this.jobs.findIndex(o => o.uuid === data.jobUuid);
                if (index >= 0) {
                    this.jobs.splice(index, 1);
                }
            });
        },

        beforeDestroy() {
            Bus.$off('onToggleJobVisibility');
        },

        methods: {
            getJobs() {
                if (this.jobsPayload.length) {
                    this.jobs = this.jobsPayload;
                    this.spinner.get_jobs = false;
                    return true;
                } else {
                    this.spinner.get_jobs = true;
                    this.$axios.$post(this.jobsUrl, this.searchFilter).then((response) => {
                        this.jobs = response.search_results.jobs;
                    }).finally(() => {
                        this.spinner.get_jobs = false;
                        this.hide = this.hideEmpty && !this.jobs.length;
                    });
                    return true;
                }
            },

            classListFrequencyItem(frequency) {
                return {
                    'job-alerts-frequency__item': true,
                    'is-active': frequency === this.selectedFrequency,
                };
            },

            updateFrequency(frequency) {
                if (this.rowType === 'saved_search') {
                    this.updateSavedSearchFrequency(frequency);
                } else {
                    this.updateDiscoverFrequency(frequency);
                }
            },

            updateSavedSearchFrequency(frequency) {
                if (frequency !== this.selectedFrequency) {
                    this.selectedFrequency = frequency;
                    const data = {
                        frequency: this.selectedFrequency,
                    };
                    this.$store.dispatch('me/updateFrequencySavedSearch', { id: this.rowId, data }).then((response) => {
                        // console.log(response);
                    });
                }
            },

            updateDiscoverFrequency(frequency) {
                if (frequency !== this.selectedFrequency) {
                    this.selectedFrequency = frequency;
                    const data = {
                        frequency: this.selectedFrequency,
                        discovery_type: this.rowTypeId,
                    };
                    this.$store.dispatch('me/updateFrequencyDiscovery', { data }).then((response) => {
                    // console.log(response);
                    });
                }
            },

            toggleListView() {
                this.$emit('toggleListView');
            },

            saveSearchAlert() {
                this.$emit('saveSearchAlert');
            },

            handleUpdateProfile() {
                this.$emit('updateProfile');
            },

            handleLogin() {
                this.$emit('loginPrompt');
            },

            goToNextJobSlide() {
                this.$refs.jobSlide.goToNext();
            },
        },
    };
